import { DropTargetMonitor } from 'react-dnd';
import { RefObject } from 'react';

// Utils
import { isBoardLike } from '../../common/elements/utils/elementTypeUtils';
import { getElementId } from '../../common/elements/utils/elementPropertyUtils';
import { inboxDropResultFn } from '../element/dnd/dropResultFn';

// Types
import { GeneralWorkspaceProps } from '../workspace/workspaceTypes';
import { ImMNElement } from '../../common/elements/elementModelTypes';

// Constants
import { ELEMENT_DND_TYPE } from '../../common/elements/elementConstants';

type FavouriteBoardsSidebarItemProps = {
    currentBoardId: string;
    elementId: string;
    connectDropTarget?: RefObject<HTMLDivElement>;
    element?: ImMNElement;
    isHovered: boolean;
};

export default (
    props: GeneralWorkspaceProps & FavouriteBoardsSidebarItemProps,
    monitor: DropTargetMonitor,
    domNode: HTMLElement,
) => {
    const dropResult = inboxDropResultFn(props, monitor, domNode);

    const itemType = monitor.getItemType();

    if (itemType !== ELEMENT_DND_TYPE) return { ...dropResult };

    const { draggedElements } = monitor.getItem();
    const acceptedElementIds = draggedElements.filter((el: ImMNElement) => isBoardLike(el)).map(getElementId);

    return {
        ...dropResult,
        acceptedElementIds,
    };
};
